module.exports = __webpack_public_path__ + "media/images/logo/aortatokens-8ea87cbbeccd7aa1fcc239c420984425.jpg";